class PhoneSerializer {
  static deSerialize(data) {
    return {
      number: String(data.TWeNumero),
      type: Number(data.TWeTipo),
      id: String(data.TWeId),
    };
  }
}

export { PhoneSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/PhoneSerializer.js